import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import * as reducks from '../../../reducks'
import Flex from '../Flex/Flex'
import Modal from '../Modal/Modal'
import Text from '../Text/Text'
import LoadingBounce from '../LoadingBounce/LoadingBounce'
import Avatar from '../Avatar/Avatar'
import styles from './customerModal.module.scss'

const CustomerModal = (props) => {
  const { visible, onSelect } = props
  const dispatch = useDispatch()

  const walletCustomer = useSelector((state) => state.walletReducer)

  useEffect(() => {
    if (visible) {
      dispatch(reducks.resources.wallet.actions.getAllWallets())
    }
  }, [visible])

  const handleSearch = (search) => {
    if (search.length >= 3) {
      dispatch(
        reducks.resources.wallet.actions.walletApplyFilters({
          search,
          page: undefined,
          perPage: undefined
        })
      )
    }

    if (search === '') {
      dispatch(reducks.resources.wallet.actions.getAllWallets())
    }
  }

  return (
    <Modal visible={visible} size="small" modalClassName={styles.modal}>
      <Flex column>
        <Flex alignItems="center" justifyContent="center">
          <Text
            size="lg"
            color="gray"
            variation="dark"
            extraBold
            lineHeight="30px"
          >
            Cliente
          </Text>
        </Flex>
        <Flex alignItems="center" justifyContent="center">
          <input
            type="search"
            placeholder="Pesquisar"
            className={styles.input}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </Flex>
        <div className={styles.list}>
          {walletCustomer.fetching && <LoadingBounce />}
          {walletCustomer.wallets.map((item) => {
            const { id, nameFantasy, groupName, tabNumber } = item

            return (
              <div
                key={id}
                className={styles.listItem}
                onClick={() => onSelect(item)}
              >
                <div>
                  <Avatar title={nameFantasy} size="small" />
                </div>
                <div className={styles.listItemDescription}>
                  <Text
                    size="xxs"
                    color="gray"
                    variation="dark"
                    lineHeight="16px"
                    extraBold
                  >
                    {nameFantasy}
                  </Text>
                  <Text
                    size="xxxs"
                    color="gray"
                    lineHeight="18px"
                    font="custom"
                  >
                    {`${groupName ?? 'N/A'} - ${tabNumber}`}
                  </Text>
                </div>
              </div>
            )
          })}
        </div>
      </Flex>
    </Modal>
  )
}

CustomerModal.defaultProps = {
  visible: false
}

CustomerModal.propTypes = {
  visible: PropTypes.bool,
  onSelect: PropTypes.func.isRequired
}

export default CustomerModal
